import Cookies from 'js-cookie'
// import { ROOT } from '../utils/config'
import { encrypt, decrypt } from '../utils/utils'
export function set (key, value, expire = 1) {
  // const o = {
  //   value,
  //   time: new Date().getTime(),
  //   expire
  // }
  if (key === 'user' || key === 'mobile') {
    value = encrypt(JSON.stringify(value))
  }
  localStorage.setItem(key, JSON.stringify(value))
  // Cookies.set(key, value, {
  //   expires: 1,
  //   domain: ROOT
  // })
}
export function get (key, domain) {
  let str = JSON.parse(localStorage.getItem(key))
  // if (!str) {
  //   if (callback) {
  //     callback()
  //   }
  //   return null
  // }
  // const o = JSON.parse(str)
  // if (o && ((new Date().getTime() - o.time) < o.expire)) {
  //   return o.value
  // }
  // let str = Cookies.get(key, {
  //   domain: domain ? ROOT : domain
  // })
  if (str) {
    if (key === 'user' || key === 'mobile') {
      str = decrypt(str)
    }
    try {
      return JSON.parse(str)
    } catch (err) {
      return str
    }
  }
  return null
}
export function getToken (callback) {
  const str = localStorage.getItem('X-Auth')
  // if (!strUser) {
  //   if (callback) {
  //     callback()
  //   }
  //   return ''
  // }
  // const user = JSON.parse(strUser)
  // return user.token
  // const str = Cookies.get('token', {
  //   domain: ROOT
  // })
  if (str) {
    return JSON.parse(str)
  } else {
    if (callback) {
      callback()
    }
    return ''
  }
}
export function remove (key) {
  localStorage.removeItem(key)
  // Cookies.remove(key, {
  //   domain: ROOT
  // })
}
export function clear () {
  localStorage.clear()
  const cookies = Cookies.get()
  if (!cookies) return
  Object.keys(cookies).forEach(key => {
    remove(key)
    // Cookies.remove(key)
  })
  // localStorage.clear()
}
